// Copyright (c) Move Closer 2023.

import { LocaleContentRule } from '@/shared/core/src/front/shared/services'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const localesRules: LocaleContentRule = {
  en: {
    cart: false,
    user: false,
    search: true,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: true
    },
    usercomChat: false
  },
  pl: {
    cart: true,
    cookiebot: false,
    search: true,
    user: true,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: true
  },
  ua: {
    cart: false,
    search: true,
    user: false,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: false
  },
  fr: {
    cart: false,
    search: true,
    user: false,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: false
  },
  ru: {
    cart: false,
    search: true,
    user: false,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: false
  },
  cz: {
    cart: false,
    search: true,
    user: false,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: false
  },
  hu: {
    cart: false,
    search: true,
    user: false,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: false
  },
  de: {
    cart: false,
    search: true,
    user: false,
    product: {
      /** Determines whether to show variants, event if they ara unavailable */
      showUnavailableVariants: false
    },
    usercomChat: false
  }
}
